import BidderDialog from "./BidderDialog";
import { json } from "react-router-dom";
import { post } from "../../apiClient";

export async function action({ params, request }) {
  const formData = await request.formData();

  try {
    await post(
      "player",
      "/api/programmatic_supply/bidders",
      {
        name: formData.get("name"),
        url: formData.get("url"),
        active: formData.get("active") === "true" ? true : false,
      },
      { signal: request.signal }
    );

    return json({ success: true });
  } catch (error) {
    switch (error.status) {
      case 400:
      case 422:
        return json(error.details, { status: error.status });
      /* istanbul ignore next */
      default:
        throw error;
    }
  }
}

const NewBidder = () => {
  return (
    <BidderDialog isEditing={false} />
  )
}

export default NewBidder;
